// Package Imports
import { QueryClient } from '@tanstack/react-query'
import axios from 'axios'

const ONE_MINUTE = 1000 * 60

// Retry only on transient failures. 4xx is a permanent client error —
// retrying just delays the error toast and wastes a network round-trip.
export const shouldRetry = (failureCount: number, error: unknown): boolean => {
  if (failureCount >= 1) return false
  if (axios.isAxiosError(error)) {
    const status = error.response?.status
    if (status && status >= 400 && status < 500) return false
  }
  return true
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Admin dashboard — explicit invalidation drives freshness, not focus.
      // Modules that need focus refetch can override (see league.hooks.ts).
      refetchOnWindowFocus: false,
      retry: shouldRetry,
      staleTime: ONE_MINUTE * 2,
      gcTime: ONE_MINUTE * 10,
    },
    mutations: {
      retry: 0,
    },
  },
})
